import React, { useEffect, useState } from "react";
import {
  Form,
  message,
  Col,
  Row,
  Button
} from "antd";
import { useForm } from "antd/lib/form/Form";
import InputIcon from "../components/forms/inputIcon";
import FormButton from "../components/forms/button";
import CustomUploadImage from "../components/forms/uploadFile";
import { useNavigate, useParams } from "react-router-dom";
import { addSection, editSection, getData } from "../store/action/sections";
import CustomSelectBox from "../components/forms/selectBox";
import CustomTextArea from "../components/forms/textArea";
import { lessonDropdown } from "../store/action/lessons";
import { domain } from "../api";
import { DeleteFilled } from "@ant-design/icons";

const posterTypes = [
  {label : 'Image', value : 'image'},
  {label : 'Video', value : 'video'},
]

export default function AddSection() {
  const Navigate = useNavigate();
  const [form] = useForm();
  const {id, lesson_id} =  useParams();
  const [data, setData] = useState({})
  const [dropdown, setDropdown] = useState([])
  const [changeCount, setChangeCount] = useState(0);

  const [removeItem, setRemoveItem] = useState({
    poster : false,
    audio : false
  })
  
  useEffect(()=>{
    lessonDropdown()
    .then(res => setDropdown(res.data))
    if(id){
      getData(id)
      .then(res => {
        setData(res.data)
        form.setFieldsValue({
          title : res?.data?.title || null,
          description : res?.data?.description || null,
          lesson_id : res?.data?.lesson_id || null,
          posterType : res?.data?.posterType || null,

        })
      })
      .catch(res => console.log("failed to retrieved"))
    }
    form.setFieldsValue({
      lesson_id : lesson_id ? lesson_id : ''

    })


  },[id, changeCount])


  const submitForm = (value) => {
    const poster = value?.poster?.[0]?.originFileObj;
    const audio = value?.audio?.[0]?.originFileObj;
    delete value.poster;
    delete value.audio;

    if (id){ 
      value['section_id'] = id
      value['removePoster'] = removeItem.poster
      value['removeAudio'] = removeItem.audio
    };
    
    const formData = new FormData();
    formData.append('data', JSON.stringify(value));
  
    if (poster) formData.append('poster', poster);
    if(audio) formData.append('audio', audio);
  
    (id ? editSection(formData) : addSection(formData))
      .then(res => {
        if (res.status) {
          message.success(res.message);
          form.resetFields(); // Immediate reset
          if(id){
            setChangeCount(prev => prev + 1);
          }
        } else {
          message.error(res.message);
        }
      })
      .catch(e => {
        console.error(e);
        message.error('Something went wrong');
      });
  };
  

  const toggleMedia = (value, action) => {
    setRemoveItem((prevState) => ({
      ...prevState,
      [value]: !action,
    }));
  };

  return (
    <>
      <div className="layout-sign-up ">
        <Row justify="center">
            <Col span={18}>
                <Form
                name="basic"
                initialValues={{}}
                onFinish={submitForm}
                className="row-col"
                form={form}
                >
                <h2 className="sub-heading text-center">{data?.title ? 'Update' : 'Add'} Section</h2>
                    <div>
                      {id &&
                      <Row align="center">
                        <Col span={12}>
                          {data?.poster &&
                            <div className="form-poster position-relative">
                           <div>{!removeItem.poster && <img src={domain + data.poster} alt="banner" className="form-poster" />}</div>
                           <Button type="primary" className="text-capitalize mt-5" onClick={()=>toggleMedia('poster', removeItem.poster)}> {!removeItem.poster ? 'delete poster' : 'revert to poster'} </Button>
                           </div>
                           
                          }
                          </Col>
                          <Col span={12}>
                            {data?.audio &&
                              <div className="audio-poster position-relative">
                            
                               <div >{!removeItem.audio && <audio src={domain + data.audio} controls></audio>}</div> 
                               <Button type="primary" className="text-capitalize" onClick={()=>toggleMedia('audio', removeItem.audio)}> {!removeItem.audio ? 'delete audio' : 'revert to audio'} </Button>
                              </div> 
                            }
                          </Col>
                        </Row>
                      }
                    </div>
                    <Col span={24} className="input-div">
                        <InputIcon name='title' message='Title' type="string" />
                    </Col>
                    <Col span={24} className="input-div">
                        <CustomTextArea name='description' message='Description'/>
                    </Col>
                    <Col span={24} className="input-div">
                        <CustomSelectBox name='lesson_id' message='Lesson' options={dropdown}/>
                    </Col>
                    <Col span={24} className="input-div">
                        <CustomSelectBox name='posterType' message='Select Poster Type' noRequired={true} options={posterTypes}/>
                    </Col>
                    <Row>
                      <Col span={12} className="input-div">
                          <CustomUploadImage name='poster' message='upload poster for the section' isRequired={false} />
                      </Col>
                      <Col span={12} className="input-div">
                          <CustomUploadImage name='audio' message='upload audio for the section' isRequired={false} />
                      </Col>
                    </Row>
                    <Row justify="center">
                        <Col span={8} >
                            <FormButton value="Submit" htmlType="submit" />
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
         
      </div>
    </>
  );
}
